export default {
  setWorkspaceGroups(state, payload) {
    state.workspaceGroups = payload;
  },
  setGroupPermissions(state, payload) {
    state.groupPermissions = payload;
  },
  setWorkspaceSocialMediaAccounts(state, payload) {
    state.workspaceSocialMediaAccounts = payload;
  },
};
